import { Injectable } from "@angular/core";
import { ApplicationSettings, IAPP_CONFIG } from "@app/constants";
import { PushPopItem } from "@app/services/push.pop.service";

@Injectable({ providedIn: "root" })
export class AppDataService {

    private _appConfig: IAPP_CONFIG = {} as IAPP_CONFIG;
    public get appConfig() {
        return this._appConfig;
    }
    public set appConfig(newValue: IAPP_CONFIG) {
        this._appConfig = newValue;
    }

    private _appSettings: ApplicationSettings;
    public get appSettings(){
        return this._appSettings
    }
    public set appSettings(newValue: ApplicationSettings) {
        this._appSettings = newValue;
    }

    private _pushPopItems: PushPopItem[];
    public get pushPopItems() {
        return this._pushPopItems
    }
    public set pushPopItems(newPushPopItems: PushPopItem[]) {
        this._pushPopItems = newPushPopItems;
    }

    private _changingState: boolean
    public get changingState() {
        return this._changingState;
    }
    public set changingState(newState: boolean) {
        this._changingState = newState
    }

    private _browserInfo: any;
    public get browserInfo() {
        return this._browserInfo
    }
    public set browserInfo(newValue: any){
        this._browserInfo = newValue;
    }

}
